export const patchDeviceSerialInCache = (queryClient, customerId, productId, dpadId, newSerial) => {
    queryClient.setQueryData(['customer-products', customerId], (old) => {
        if (!old)
            return;
        return old.map((product) => product.productId !== productId
            ? product
            : Object.assign(Object.assign({}, product), { devices: product.devices.map((device) => device.dpadId === dpadId
                    ? Object.assign(Object.assign({}, device), { serialNumber: newSerial }) : device) }));
    });
};
